"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
function UndrawUpVote(p) {
  var primaryColor = p.primaryColor,
    height = p.height,
    style = p.style,
    props = __rest(p, ["primaryColor", "height", "style"]);
  var styleProps = __assign({
    width: '100%',
    height: height
  }, style);
  return React.createElement("svg", __assign({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 724.724 476.685",
    style: styleProps
  }, props), React.createElement("path", {
    d: "M708.224 434.548H67.385a16.519 16.519 0 01-16.5-16.5V22.894a12.102 12.102 0 0112.088-12.088h649.454a12.311 12.311 0 0112.297 12.297v394.945a16.519 16.519 0 01-16.5 16.5z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M687.504 413.716H90.259c-8.755 0-15.877-6.67-15.877-14.869V54.742c0-6.08 5.278-11.026 11.765-11.026h605.274c6.595 0 11.96 5.028 11.96 11.208v343.923c0 8.199-7.122 14.869-15.877 14.869z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M724.494 24.95H50.654v-8.4A16.574 16.574 0 0167.214 0h640.72a16.574 16.574 0 0116.56 16.55z",
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 80.749,
    cy: 12.5,
    r: 4.283,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 97.008,
    cy: 12.5,
    r: 4.283,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 113.267,
    cy: 12.5,
    r: 4.283,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 253.839,
    y: 136.382,
    width: 324,
    height: 41.028,
    rx: 20.514,
    fill: "#e6e6e6"
  }), React.createElement("rect", {
    x: 253.839,
    y: 204.27,
    width: 324,
    height: 41.028,
    rx: 20.514,
    fill: "#e6e6e6"
  }), React.createElement("rect", {
    x: 253.839,
    y: 272.159,
    width: 324,
    height: 41.028,
    rx: 20.514,
    fill: "#e6e6e6"
  }), React.createElement("circle", {
    cx: 217.839,
    cy: 224.784,
    r: 21,
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M225.337 223.338l-6.377-6.858a1.53 1.53 0 00-2.242 0l-6.377 6.858a1 1 0 101.466 1.363l5.03-5.412v13.288a1 1 0 002 0v-13.292l5.033 5.416a1 1 0 001.467-1.363z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 217.839,
    cy: 292.673,
    r: 21,
    fill: "#e6e6e6"
  }), React.createElement("path", {
    d: "M225.337 291.227l-6.377-6.858a1.53 1.53 0 00-2.242 0l-6.377 6.858a1 1 0 101.466 1.363l5.03-5.413v13.289a1 1 0 002 0v-13.293l5.033 5.416a1 1 0 001.467-1.362z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 217.839,
    cy: 156.895,
    r: 21,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M225.337 155.45l-6.377-6.859a1.53 1.53 0 00-2.242 0l-6.377 6.858a1 1 0 101.466 1.363l5.03-5.412v13.288a1 1 0 002 0v-13.292l5.033 5.416a1 1 0 001.467-1.363z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M198.147 156.335a10.056 10.056 0 00-10.987 10.819l-32.707 14.395 15.602 10.07 28.667-15.213a10.11 10.11 0 00-.575-20.071z",
    fill: "#a0616a"
  }), React.createElement("circle", {
    cx: 66.215,
    cy: 113.817,
    r: 24.561,
    fill: "#a0616a"
  }), React.createElement("path", {
    fill: "#a0616a",
    d: "M110.667 464.031l12.26-.001 5.832-47.288-18.094.001.002 47.288z"
  }), React.createElement("path", {
    d: "M107.54 460.028l24.144-.001a15.386 15.386 0 0115.387 15.386v.5l-39.53.002z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    fill: "#a0616a",
    d: "M59.667 464.031l12.26-.001 5.832-47.288-18.094.001.002 47.288z"
  }), React.createElement("path", {
    d: "M56.54 460.028l24.144-.001a15.386 15.386 0 0115.387 15.386v.5l-39.53.002zM57.272 452.834a4.501 4.501 0 01-1.524-3.36l-.577-177.202 64.022-2.467.47-.018 10.53 106.292 1.318 67.714a4.485 4.485 0 01-3.973 4.557l-15.54 1.829a4.498 4.498 0 01-5.023-4.295l-2.767-71.937-13.434-44.784a1.5 1.5 0 00-2.857.554l-5.23 117.763a4.493 4.493 0 01-3.944 4.236l-17.946 2.209a4.489 4.489 0 01-3.525-1.091z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M53.227 278.562l-18.968-77.03c-5.91-24.002 7.59-48.169 30.097-53.872a38.196 38.196 0 0131.108 5.547 44.132 44.132 0 0118.68 30.792l12.39 91.191a4.5 4.5 0 01-4.34 5.105l-64.48 1.69h-.117a4.526 4.526 0 01-4.37-3.424z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M132.688 207.397L84.6 184.04a16.155 16.155 0 1116.446-27.678l38.909 27.786 42.001-16.725a4.484 4.484 0 014.932 1.087l5.664 5.98a4.5 4.5 0 01-.798 6.857l-37.603 24.67a21.882 21.882 0 01-21.463 1.38z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M56.716 136.836a12.909 12.909 0 01-5.596-1.155c-.783-.345-1.596-.628-2.378-.973-6.904-3.045-11.452-11.439-11.615-19.886a30.305 30.305 0 019.36-22.05 33.71 33.71 0 0120.441-8.82c7.95-.69 16.902 1.611 21.344 9.169a8.845 8.845 0 011.31 6.882 4.504 4.504 0 01-1.088 1.906c-1.984 2.014-3.961.5-5.984.366-2.78-.184-5.276 2.384-6.174 5.393s-.502 6.322.222 9.39l.014.058a5.15 5.15 0 01-4.56 6.277c-3.057.276-6.416.447-7.375-.002-1.877-.88-4.4-.686-5.492 1.267a7.61 7.61 0 00-.694 2.289c-.98 5.095-.755 4.794-1.735 9.89z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M49.77 319.438a10.056 10.056 0 00-3.573-15l4.606-35.436-16.69 8.14-1.816 32.403a10.11 10.11 0 0017.473 9.893z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M51.686 297.85a4.6 4.6 0 01-.938.22l-16.845 2.13a4.5 4.5 0 01-5.064-4.47l.133-117.62a14.265 14.265 0 0112.16-14.028 14.189 14.189 0 0116.15 15.407l-4.895 50.688 2.294 63.266a4.474 4.474 0 01-2.995 4.408z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M207 476.685H1a1 1 0 010-2h206a1 1 0 110 2z",
    fill: "#ccc"
  }));
}
exports.default = UndrawUpVote;